export default `
  mutation makePaymentviaToken (
    $txnid: ID!
    $token: String!
    $authorization: String
  ) {
    receipt: makePayment (
      txnid: $txnid,
      cardtoken: $token,
      authorization: $authorization,
    ) {
      ...Receipt
    }
  }

  mutation makePaymentviaPayerID (
    $txnid: ID!,
    $payerid: String!
    $authorization: String
  ) {
    receipt: makePayment (
      txnid: $txnid,
      payerid: $payerid,
      authorization: $authorization,
    ) {
      ...Receipt
    }
  }

  mutation makePaymentviaTokenwithAmount (
    $txnid: ID!
    $amount: Float
    $token: String!
    $authorization: String
  ) {
      receipt: makePayment (
      txnid: $txnid,
      amount: $amount,
      cardtoken: $token,
      authorization: $authorization,
    ) {
      ...Receipt
    }
  }

  mutation makePaymentviaPayerIDwithAmount (
    $txnid: ID!,
    $amount: Float
    $payerid: String!
    $authorization: String
  ) {
    receipt: makePayment (
      txnid: $txnid,
      amount: $amount,
      payerid: $payerid,
      authorization: $authorization,
    ) {
      ...Receipt
    }
  }
`
